// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Finland from '../_raw/flag/icon_flag_finland.png';

export default () => <img src={Finland} alt="Finland" />;
